import styles from "./CompanyInquiry.module.css";
import { uticaCompany, foundersCompany} from "../../../../constants/data";
import Letter from "../../../letter/Letter";
import unigLogo from "../../../../assets/img/UNIG-Logo-2L-Color.png";
import foundersLogo from "../../../../assets/img/FoundersLogo-NoTagline_fullcolor 1.png";

export default function CompanyInquiry({ setUwCompany }) {
  return (
    <div className={styles.fullWidth}>
      <div className={styles.companyPrompt}>
        <Letter />
        <p className={styles.choice}>
          <i>Please choose your insurance provider.</i>
        </p>

        <div className={styles.row}>
          <div className={styles.col}>
            <div className={styles.imageDiv}>
              <img
                src={unigLogo}
                alt="Utica National Icon"
                onClick={e => setUwCompany(uticaCompany)}
              />
            </div>
            <button onClick={e => setUwCompany(uticaCompany)} type="button">
              A Utica National Company
            </button>
            <ul aria-label="A list of companies that are Utica National companies">
              <li>Utica Mutual Insurance Company</li>
              <li>Graphic Arts Mutual Insurance Company</li>
              <li>Republic-Franklin Insurance Company </li>
              <li>Utica National Assurance Company</li>
              <li>Utica National Insurance Company of Texas</li>
              <li>Utica National Insurance Company of Ohio</li>
              <li>Utica Specialty Risk Insurance Company</li>
              <li>Utica Lloyd's of Texas</li>
            </ul>
          </div>
          <div className={styles.col}>
            <hr className={styles.smallScreenDivider} />
            <div className={styles.imageDiv}>
              <img
                src={foundersLogo}
                alt="Founders Insurance Icon"
                onClick={e => setUwCompany(foundersCompany)}
              />
            </div>
            <button onClick={e => setUwCompany(foundersCompany)} type="button">
              Founders Insurance Company
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
